// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.va2ajOi3uHLD7POFxuPD {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/merchant/v2/FullSizeDownload/FullSizeDownloadButton.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,mBAAmB;AACrB","sourcesContent":[".progress {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export var progress = `va2ajOi3uHLD7POFxuPD`;
export default ___CSS_LOADER_EXPORT___;
